import { render, staticRenderFns } from "./ClientsSelectInput.vue?vue&type=template&id=f485c4b6"
import script from "./ClientsSelectInput.vue?vue&type=script&lang=js"
export * from "./ClientsSelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports